module.exports = __webpack_public_path__ + "media/img/logo-Makaira-f99e7441b5b2877b49911a1b1ca23a19.svg";